import {
  MetricSummaryCard,
  type MetricSummaryCardProps,
} from '../MetricSummaryCard/MetricSummaryCard';

/** Figma `972:20771`. */
export function NegativeConversationCard(props: MetricSummaryCardProps) {
  return (
    <MetricSummaryCard
      {...props}
      copy={{
        title: 'Negative conversation',
        helpText: 'How many of your mentions carried negative sentiment.',
        helpSupportingText:
          'A count rather than a rate, so it can be read against Total mentions beside it. Rising is worse, which is why its badge goes red when the number goes up.',
      }}
    />
  );
}
